module.exports = __webpack_public_path__ + "static/media/buffaloTemplates.fd3b5e09.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logs/buffalo/buffaloTemplates.png
// module id = 719
// module chunks = 0